import $axios from "../api/accessor";
import { $api } from "../api/api";

export const ContactServices={
      async SendMail(payload: any) {
    try {
      const response = await $axios.post($api("post_sendMail"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
}